<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <SelectFormGroup
            v-if="!edit"
            v-model="data.block_driver"
            name="block_driver"
            label="Driver"
            :error="(errors.block_driver || [])[0]"
            :options="blockDriverOptions"
        />

        <BlockDriverParameterForm
            v-if="data.block_driver"
            v-model="data.block_driver_parameters"
            :driver="data.block_driver"
            :errors="blockDriverParametersErrors"
            :portal="portal"
        />

        <hr>

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import BlockDriverParameterForm from "../BlockDriverParameterForms/Base";
import SelectFormGroup from "../../../../vendor/forms/FormGroups/Block/Select";
import SubmitFormGroup from "../../../../vendor/forms/FormGroups/Block/Submit";

export default {
  components: {
    BlockDriverParameterForm,
    SelectFormGroup,
    SubmitFormGroup,
  },

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    edit: {
      required: false,
      type: Boolean,
      default: false
    },

    blockDrivers: {
      required: true,
      type: Array
    },

    contentRow: {
      required: true,
      type: Object
    },

    portal: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  },

  computed: {
    blockDriverOptions() {
      return this.blockDrivers.map(blockDriver => ({
        value: blockDriver.id,
        label: blockDriver.attributes.name,
        disabled: blockDriver.attributes.width > this.remainingWidth
      }))
    },

    remainingWidth() {
      return 3 - this.contentRow.attributes.content_blocks.reduce((width, contentBlock) => width + contentBlock.width, 0)
    },

    blockDriverParametersErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('block_driver_parameters.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('block_driver_parameters.'.length)]: entry[1]
          }), {})
    }
  }
}
</script>